import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import {
  FaStar, FaSwimmingPool, FaUtensils, FaSnowflake,
  FaBath, FaBed, FaUser, FaArrowLeft, FaArrowRight
} from "react-icons/fa";
import { motion } from "framer-motion";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Styles/PropertyList.css";

const PropertyCard = ({ property }) => {
  const navigate = useNavigate();
  const sliderImages = property.images.slice(0, 4);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const handleClick = () => {
    navigate(`/property/${encodeURIComponent(property.title)}`, {
      state: { property },
    });
  };

  return (
    <motion.div
      className="property-card"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      initial={{ opacity: 0, y: 50 }}             // start slightly lower and invisible
      whileInView={{ opacity: 1, y: 0 }}          // animate when scrolled into view
      viewport={{ once: true, amount: 0.3 }}      // triggers once when 30% visible
      transition={{ duration: 0.6, ease: "easeOut" }}
      whileHover={{ scale: 1.03 }}
    >
      {/* IMAGE / SLIDER */}
      <div className="property-image">
        <Slider {...sliderSettings}>
          {sliderImages.map((img, idx) => (
            <img key={idx} src={img} alt={property.title} className="property-slider-image" />
          ))}
        </Slider>

        <div className="rating-badge">
          <FaStar /> {property.rating.toFixed(2)}
        </div>

        <div className="price-badge">{property.priceTag}</div>

        <div className="hover-overlay"></div>
      </div>

      {/* INFO SECTION */}
      <motion.div
        className="property-info"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <h3 className="property-title">{property.title}</h3>

        <div className="property-stats">
          <span><FaUser /> {property.guests}</span>
          <span><FaBed /> {property.bedrooms}</span>
          <span><FaBath /> {property.bathrooms}</span>
        </div>

        <div className="property-amenities">
          {property.amenities.map((a, idx) => (
            <span key={idx} className="amenity">
              {amenityIcon(a)} {a}
            </span>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

// Arrow buttons
const NextArrow = ({ onClick }) => (
  <div
    className="custom-arrow next-arrow"
    onClick={(e) => { e.stopPropagation(); onClick(); }}
  >
    <FaArrowRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    className="custom-arrow prev-arrow"
    onClick={(e) => { e.stopPropagation(); onClick(); }}
  >
    <FaArrowLeft />
  </div>
);

// Amenity icons
const amenityIcon = (name) => {
  switch (name) {
    case "Swimming pool": return <FaSwimmingPool className="inline mr-1" />;
    case "Kitchen": return <FaUtensils className="inline mr-1" />;
    case "Air conditioning": return <FaSnowflake className="inline mr-1" />;
    case "Private Pool": return <FaSwimmingPool className="inline mr-1" />;
    default: return null;
  }
};

export default PropertyCard;
























// import React from "react";
// import { useNavigate } from "react-router-dom";
// import Slider from "react-slick";
// import {
//   FaStar, FaSwimmingPool, FaUtensils, FaSnowflake,
//   FaBath, FaBed, FaUser, FaArrowLeft, FaArrowRight
// } from "react-icons/fa";

// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "../Styles/PropertyList.css";

// const PropertyCard = ({ property }) => {
//   const navigate = useNavigate();

//   const sliderImages = property.images.slice(0, 4);

//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 400,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//   };

//   const handleClick = () => {
//     navigate(`/property/${encodeURIComponent(property.title)}`, {
//       state: { property },
//     });
//   };

//   return (
//     <div className="property-card">
//   <div className="property-image" onClick={handleClick} style={{ cursor: "pointer" }}>

//     <Slider {...sliderSettings}>
//       {sliderImages.map((img, idx) => (
//         <img key={idx} src={img} alt={property.title} className="property-slider-image" />
//       ))}
//     </Slider>

//     <div className="rating-badge">
//       <FaStar /> {property.rating.toFixed(2)}
//     </div>

//     <div className="price-badge">{property.priceTag}</div>

//     {/* Hover overlay inside image only */}
//     <div className="hover-overlay"></div>

//   </div>

//   <div className="property-info">
//     <h3 className="property-title">{property.title}</h3>

//     <div className="property-stats">
//       <span><FaUser /> {property.guests}</span>
//       <span><FaBed /> {property.bedrooms}</span>
//       <span><FaBath /> {property.bathrooms}</span>
//     </div>

//     <div className="property-amenities">
//       {property.amenities.map((a, idx) => (
//         <span key={idx} className="amenity">
//           {amenityIcon(a)} {a}
//         </span>
//       ))}
//     </div>
//   </div>
// </div>

//   );
// };

// // Arrow buttons (hidden until hover)
// const NextArrow = ({ onClick }) => (
//   <div
//     className="custom-arrow next-arrow"
//     onClick={(e) => { e.stopPropagation(); onClick(); }}
//   >
//     <FaArrowRight />
//   </div>
// );

// const PrevArrow = ({ onClick }) => (
//   <div
//     className="custom-arrow prev-arrow"
//     onClick={(e) => { e.stopPropagation(); onClick(); }}
//   >
//     <FaArrowLeft />
//   </div>
// );

// // Amenity icons
// const amenityIcon = (name) => {
//   switch (name) {
//     case "Swimming pool": return <FaSwimmingPool className="inline mr-1" />;
//     case "Kitchen": return <FaUtensils className="inline mr-1" />;
//     case "Air conditioning": return <FaSnowflake className="inline mr-1" />;
//     default: return null;
//   }
// };

// export default PropertyCard;
